import axios from "axios";

const GATEWAY_BASE = process.env.REACT_APP_API_URL;

// Add /coaching/v1 prefix for production/gateway API (not localhost)
const getBaseURL = () => {
  if (GATEWAY_BASE && !GATEWAY_BASE.includes('localhost')) {
    return `${GATEWAY_BASE}/coaching/v1`;
  }
  return GATEWAY_BASE;
};


const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: getBaseURL(),
});

let hasNotifiedDisconnect = false;

const notifyDisconnected = () => {
  if (hasNotifiedDisconnect || typeof window === 'undefined') {
    return;
  }
  hasNotifiedDisconnect = true;
  window.dispatchEvent(new Event('api-disconnected'));
};



axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (!error?.response || [502, 503, 504].includes(status)) {
      notifyDisconnected();
    }
   
    return Promise.reject(error);
  }
);

// Create a separate axios instance for core-backend endpoints (like profile upload)
export const coreBackendAxios = axios.create({
  withCredentials: true,
  baseURL: GATEWAY_BASE, // Use raw base URL without /coaching/v1 prefix
});

coreBackendAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (!error?.response || [502, 503, 504].includes(status)) {
      notifyDisconnected();
    }
   
    return Promise.reject(error);
  }
);

export default axiosInstance;
